import { useEffect, useState } from 'react';
import { Trans, useLingui } from '@lingui/react/macro';
import { remove } from 'lodash';
import useRolesStore from 'store/roles';
import { cloneDeep } from 'lodash';
import { Banner } from '@thermon-platforms/thermon-ui-core';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';


const roleModel = {
  name: undefined,
  permissions: []
}

function EditModal({role, close, dismiss}) {
  const { _ } = useLingui();
  const [errors, setErrors] = useState();
  const [tempRole, setTempRole] = useState();
  const [rolesStore, rolesStoreActions] = useRolesStore();
  const [loading, setLoading] = useState(false);
  const isNew = !role;

  useEffect(() => {
    setTempRole(cloneDeep(role || roleModel));
  }, [role])

  async function finish() {
    setLoading(true);
    const res = await rolesStoreActions.save(tempRole);
    setLoading(false);
    if (!res) {
      close();
    } else {
      setErrors(res);
    }
  }

  function togglePermission(permission) {
    if (tempRole.permissions.includes(permission)) {
      remove(tempRole.permissions, item => item == permission);
    } else {
      tempRole.permissions.push(permission);
    }
  }

  if (!tempRole) return null;

  return (
    <I18nProvider i18n={i18n}>
      <header>
        <h3>
          {!isNew ?
            <><Trans>Configure Role</Trans>: <strong>{role.name}</strong></> :
            <Trans>Configure New Role</Trans>
          }
        </h3>
      </header>
      <section>
        <Banner show={errors} status="alert" small={true}>
          <Trans>There was an error saving this role.</Trans>
        </Banner>
        <ul className="form">
          <li>
            <label><Trans>Name</Trans></label>
            <input
              type="text"
              defaultValue={tempRole.name}
              onChange={event => tempRole.name = event.target.value}
              className={errors?.name ? 'error' : null}
            />
            {errors?.name?.length ?
              <p className="error-text">{errors.name}</p>
            : null}
          </li>
          <li>
            <label><Trans>Permissions</Trans></label>
            <div className="input-group">
              {Object.keys(rolesStore.permissions).map(permission =>
                <label key={`input-permission-${permission}`}>
                  <input
                    type="checkbox"
                    defaultChecked={tempRole.permissions.includes(permission)}
                    value={permission}
                    onChange={event => togglePermission(event.target.value)}
                  /> {_(rolesStore.permissions[permission])}
                </label>
              )}
            </div>
            {errors?.permissions?.length ?
              <p className="error-text">{errors.permissions}</p>
            : null}
          </li>
        </ul>
      </section>
      <footer>
        <button onClick={dismiss}>
          <Trans>Cancel</Trans>
        </button>
        <button
          className={`primary ${loading ? 'processing' : ''}`}
          onClick={finish}
          disabled={loading}
        >
          <Trans>Save</Trans>
        </button>
      </footer>
    </I18nProvider>
  );
}

export default EditModal;
